module.exports = __webpack_public_path__ + "assets/not-validated.0b6ac1ad.svg";